import { render, staticRenderFns } from "./ContentEN.vue?vue&type=template&id=add50062"
import script from "./ContentEN.vue?vue&type=script&lang=js"
export * from "./ContentEN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports